import type {
    FormSchema,
    TurnstileFormHiddenPayload,
    TurnstileFormReadOnlyField,
} from "../../forms/types";
import type { ProductData } from "./ProductInfoCard.types";

export const productEnquirySchema: FormSchema = {
    fields: [
        {
            name: "name",
            label: "Name",
            type: "text",
            required: true,
            placeholder: "Your name",
        },
        {
            name: "email",
            label: "Email",
            type: "email",
            required: true,
            placeholder: "you@example.com",
        },
        {
            name: "enquiryType",
            label: "What would you like to know?",
            type: "select",
            required: true,
            options: [
                { label: "Stock availability", value: "stock" },
                { label: "Colours and finishes", value: "colours" },
                { label: "Delivery options", value: "delivery" },
                { label: "Dimensions", value: "dimensions" },
                { label: "Price or quote", value: "price" },
                { label: "Product recommendation", value: "recommendation" },
                { label: "General question", value: "general" },
            ],
        },
        {
            name: "message",
            label: "Message",
            type: "textarea",
            required: true,
            minLength: 10,
            placeholder: "Tell us what you need to know…",
        },
    ],
};

export const getProductUrl = (canonicalUrl = "") => canonicalUrl || "";

export const getProductStockStatus = (product: ProductData) => {
    if (product?.flags?.isInStock === true) return "In stock";
    if (product?.flags?.isInStock === false) return "Check availability";
    return "Not specified";
};

export const getProductImage = (product: ProductData) => {
    return (
        product?.featureImage?.original ||
        product?.featureImage?.thumbnail ||
        product?.images?.[0]?.original ||
        product?.images?.[0]?.thumbnail ||
        ""
    );
};

export const buildProductEnquiryReadOnlyFields = (
    product: ProductData,
): TurnstileFormReadOnlyField[] => {
    const title = product?.basic?.name || product?.title || "Product";
    const stockStatus = getProductStockStatus(product);

    return [
        { name: "productTitle", label: "Product", value: title },
        { name: "stockStatus", label: "Stock status", value: stockStatus },
    ];
};

export const buildProductEnquiryHiddenPayload = (
    product: ProductData,
    canonicalUrl = "",
): TurnstileFormHiddenPayload => {
    return {
        productId: product?.id || "",
        productTitle: product?.basic?.name || product?.title || "Product",
        productUrl: getProductUrl(canonicalUrl),
        productImage: getProductImage(product),
        stockStatus: getProductStockStatus(product),
        source: "ProductInfoCard",
    };
};
